import { needsAttention, type RowFilter } from '../../domain/rowFilter.js';
import type { MatrixPageState } from '../../hooks/useMatrixPageState.js';
import { GridToolbar } from './GridToolbar.js';
import type { EnvironmentHandlers, MatrixColumn } from './types.js';

/** Every row `needsAttention` reads — either grid's row satisfies it structurally. */
type AttentionRow = Parameters<typeof needsAttention>[0][number];

/**
 * The grid wiring Studios and Games build the same way, following the `MatrixOverlays`
 * precedent: the toolbar (search/segment/status, the environment chooser, the attention count)
 * and the column kebab's handlers `MatrixGrid` takes. Spread onto either grid alongside its own
 * rows, columns and selection.
 */
export const gridChrome = (
    matrix: Pick<MatrixPageState, 'setInbox' | 'pulls' | 'push'>,
    filters: RowFilter,
    patch: (patch: Partial<RowFilter>) => void,
    columns: MatrixColumn[],
    rows: readonly AttentionRow[],
) => ({
    toolbar: (
        <GridToolbar
            value={filters}
            onChange={patch}
            attention={needsAttention(rows, filters.environment)}
            environments={columns.map((c) => c.name)}
        />
    ),
    onEnvironment: {
        pull: matrix.pulls.pull,
        push: (environment: string) => matrix.push.open({ cells: null, environments: [environment] }),
        inbox: matrix.setInbox,
    } satisfies EnvironmentHandlers,
});
